import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import Moment from 'react-moment';
import SvgIcon from 'react-icons-kit';
import {plus} from 'react-icons-kit/icomoon/plus';
import swal from 'sweetalert';

var Config = require('../../../config');

class ModalOffers extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		
		this.state = {
		    show: false,
		    photo:"",
			last_donation_date:"",
			donation_type:"",
			extraction_type:"",
			total_donations:0,
			total_last_year:0,
			lookup_group:"",
			lookup_rh:"",
			status_bar_color:"",
			temporality:"",
			group_test:{}
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false});
	}

	handleShow(donor_id) {
		this.setState({show: true});

		fetch(Config.default.apiGateway.URL+'donors?option=loadDonor&donor_id='+donor_id,{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(error) {
                swal('¡Error', error, 'error');
              });
	        }
	    })
		.then((response) => {
			if(response !== "" && response !== null){
				this.setState({
					total_donations:response.total_num,
					total_last_year:response.total_month,
					photo:response.person.photo!==null?'data:image/jpeg;base64,'+response.person.photo:"",
					lookup_group:response.person.lookup_group,
					lookup_rh:response.person.lookup_rh,
					group_test:response.offer.group_test,
					last_donation_date:response.offer.date,
					donation_type:response.offer.donation_type,
					extraction_type:response.offer.extraction_type
				});
			}
		})
	}

	concatGroupRH(){
		var res = "";

		if(this.state.lookup_rh==="POSITIVO"){
			res = this.state.lookup_group+'+'
		}else{
			res = this.state.lookup_group+'-';
		}
		if(res.length>0){
			if(this.state.group_test !== null){
				if(this.state.group_test.lectina !== null){
					var position = 1;
					res = [res.slice(0, position), this.satet.group_test.lectina, res.slice(position)].join('');
				}
			}
		}


		return res;
	}


	render(){
		const { t } = this.props;
		return(
			<div>
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_offers.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12" style={{paddingBottom:"10px"}}>
			        		<div className="col-xs-12" style={{textAlign:"center",align:"center"}}>
				        		{this.state.lookup_group!=="" && this.state.lookup_group !== null?
									<div className="col-xs-12 col-sm-1" >
										<h2 style={{color:"red"}}>
											{this.concatGroupRH()}
										</h2>
									</div>
								:null}
				        		{this.state.photo.length===0?
			        				<img style={{height:'180px',width:'168px',textAlign:"center"}} src="../../default_user.jpg" alt="USER"/>
			        				:<img style={{height:'180px',width:'168px',textAlign:"center"}} src={this.state.photo} alt="default"/>
				        		}
				        	</div>
					
							{this.state.total_donations !== 0?
				        	<div className="col-xs-12" >
				        		<div className="col-xs-12 " >
						        	<span >
						        		{t('content.offers.form.last_donation')}
						        	</span>
					        	</div>
					        	<div className="col-xs-12 col-sm-4" >
						        	<span className="color-font">
						        		{this.state.last_donation_date}
						        	</span>
					        	</div>
					        	<div >
					        		<div className="col-xs-12 col-sm-4">
							        	<span className="color-font">
							        		{this.state.donation_type}
							        	</span>
						        	</div>
							        <div className="col-xs-12 col-sm-4" >
							        	<span className="color-font">
							        		{this.state.extraction_type}
							        	</span>
							        </div>
						        </div>
				        	</div>:null}
			        	</div>
			        	<div style={{marginTop:"10px"}}>
				        	<div className="col-xs-12">
				        		<div className="col-xs-12 col-sm-offset-4 col-sm-4" >
				        			<span>
				        				{t('content.offers.form.total_donations')}: {this.state.total_donations}
				        			</span>
				        		</div>
				        		<div className="col-xs-12 col-sm-2">
					        		<button>
					        			<SvgIcon size={10} icon={plus} />
					        		</button>
				        		</div>
				        	</div>
				        	<div className="col-xs-12" >
				        		<div className="col-xs-12 col-sm-offset-4 col-sm-4" >
				        			<span >
				        				{t('content.offers.form.last_12_months')}: {this.state.total_last_year}
				        			</span>
				        		</div>
				        		<div className="col-xs-12 col-sm-2">
					        		<button>
					        			<SvgIcon size={10} icon={plus} />
					        		</button>
				        		</div>
				        	</div>
				        </div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')} onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
	      	</div>
		);
	}
}

export default translate('translations')(ModalOffers);